/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** The type of the phone number. */
export enum PhoneType {
    PHONE_TYPE_LAND_LINE = 'PHONE_TYPE_LAND_LINE',
    PHONE_TYPE_MOBILE = 'PHONE_TYPE_MOBILE',
}

export interface EngineOil {
    /** UUIDv4 */
    id: Id;
    /** Descriptive state of the engine oil level */
    state: EngineOilState;
    /** Severity level for UI display (determines color) */
    status: Status;
    /** Engine oil level as a percentage */
    measurement?: EngineOilMeasurement;
    /** The device type that produced the engine oil reading */
    source_device: SourceDevice;
    /** The source type of the engine oil reading */
    source_type: SourceType;
    measured_at: MeasuredAt;
    asset_id: AssetId;
    /** Active engine oil DTC information */
    active_dtc?: ActiveDtc;
    /** Preconditions for a valid engine oil DID measurement */
    preconditions?: EngineOilPreconditions;
    /** The booked ServiceCare product for the asset */
    booked_product?: BookedProduct;
    /** The vehicle model year (delivery date). Used to determine feature support (e.g., TGE vehicles older than MY 2022 do not support engine oil level reading). */
    model_year?: ModelYear;
}

/**
 * Descriptive state of the engine oil level
 * @example "ok"
 */
export type EngineOilState = string | null;

/**
 * Severity level for UI display (determines color)
 * @example "normal"
 */
export type Status = string | null;

/**
 * Engine oil level as a percentage
 * @format float
 * @example 42
 */
export type EngineOilMeasurement = number | null;

/**
 * The device type that produced the engine oil reading
 * @example "cm4"
 */
export type SourceDevice = string;

/**
 * The source type of the engine oil reading
 * @example "sensor_signal_series"
 */
export type SourceType = string;

export interface MeasuredAt {
    /**
     * Mileage at the time of measurement in kilometers
     * @format float
     * @example 346003.53
     */
    mileage_km?: number;
    /**
     * Timestamp of the measurement
     * @format date-time
     * @example "2026-05-04T11:34:02.231Z"
     */
    date: string;
}

/** Active engine oil DTC information */
export type ActiveDtc = {
    /**
     * The SPN number of the active DTC
     * @format int32
     * @example 55913
     */
    spn: number;
    /**
     * The type of engine oil DTC (critically_low or critically_overfilled)
     * @example "critically_low"
     */
    type: string;
} | null;

/** Preconditions for a valid engine oil DID measurement */
export type EngineOilPreconditions = {
    measured_at?: MeasuredAt;
    /**
     * Indicates if the external tester is disconnected
     * @example true
     */
    is_external_tester_disconnected?: boolean;
    /**
     * Indicates if the vehicle is standing on a flat surface (pitch and roll angle with valid values)
     * @example true
     */
    is_standing_on_flat_surface?: boolean;
    /**
     * Indicates if the standing time requirement is met
     * @example false
     */
    is_standing_time_valid?: boolean;
    /**
     * Indicates whether the ignition has been on for the required minimum duration before the engine starts
     * @example true
     */
    is_ignition_on_valid?: boolean;
    /**
     * Indicates if the engine is not running
     * @example true
     */
    is_engine_not_running?: boolean;
    /**
     * Indicates if the engine oil level measurement is valid
     * @example true
     */
    is_engine_oil_level_valid?: boolean;
} | null;

/** @format uuid */
export type AssetId = string;

/**
 * The booked ServiceCare product for the asset
 * @example "service_care_m"
 */
export type BookedProduct = string | null;

/**
 * The vehicle model year (delivery date). Used to determine feature support (e.g., TGE vehicles older than MY 2022 do not support engine oil level reading).
 * @format date
 * @example "2023-01-01"
 */
export type ModelYear = string | null;

/**
 * UUIDv4
 * @format uuid
 */
export type Id = string;

/** Fleet-table selection (assets, accounts and/or workshops) plus paging and sorting. */
export interface EngineOilTableRequest {
    asset_ids: AssetId[];
    account_ids?: string[];
    workshop_ids?: string[];
    /**
     * Page number
     * @format int32
     * @min 0
     * @default 0
     */
    page?: number;
    /**
     * Number of items per page.
     * @format int32
     * @min 1
     * @max 100
     * @default 20
     */
    size?: number;
    /**
     * Column to sort by.
     * @default "name"
     */
    sort_by?: string;
    /**
     * Sort direction.
     * @default "asc"
     */
    sort_order?: string;
}

export interface EngineOilTableResponse {
    items: EngineOilTableItem[];
    /**
     * Page number of this result
     * @format int32
     */
    page: number;
    /**
     * Requested page size.
     * @format int32
     */
    size: number;
    /**
     * Total number of matching items across all pages.
     * @format int64
     */
    total_items: number;
    /**
     * Total number of pages for the current page size.
     * @format int32
     */
    total_pages: number;
}

/** Engine oil status for one asset, enriched with vehicle identity. */
export interface EngineOilTableItem {
    asset_id: AssetId;
    /**
     * Vehicle name
     * @example "Truck 0042"
     */
    name?: string | null;
    /** Vehicle identification number */
    vin?: string | null;
    /** Customer (account) name */
    customer?: string | null;
    /** Identifier of the assigned workshop. Only included for NSC (admin) users. */
    workshop_id?: string | null;
    /** Assigned workshop name. Only included for NSC (admin) users. */
    workshop?: string | null;
    /** Descriptive state of the engine oil level */
    state: EngineOilState;
    /** Severity level for UI display (determines color) */
    status: Status;
    /** Engine oil level as a percentage */
    measurement?: EngineOilMeasurement;
    measured_at: MeasuredAt;
    /** Active engine oil DTC information */
    active_dtc?: ActiveDtc;
}

/** The workshop assignment for an asset, with the fleet account (customer) and assigned contact person. */
export interface Assignment {
    asset_id: AssetId;
    /** Identifier of the workshop assigned to the asset. */
    workshop_id: string;
    /** The contact person assigned to the asset. */
    contact_person: ContactPerson;
    /** The fleet account (customer) that owns the asset. */
    fleet_account: FleetAccount;
}

/** The fleet account (customer) that owns the asset. */
export interface FleetAccount {
    /** Fleet account identifier. */
    id: string;
    /** Fleet account (customer) name. */
    name?: string | null;
    /** A postal address. */
    address?: Address;
}

/** The contact person assigned to the asset. */
export interface ContactPerson {
    /**
     * User id of the contact person.
     * @format uuid
     */
    id: string;
    /** Full name of the contact person. */
    name: string;
    /** Email address of the contact person. */
    email?: string | null;
    /** Phone numbers of the contact person. */
    phone_numbers: PhoneNumber[];
}

/** A phone number of the contact person. */
export interface PhoneNumber {
    /** The phone number in international format. */
    number: string;
    /** The type of the phone number. */
    type: PhoneType;
}

/** The workshop assigned to an asset, with its display name and address. */
export interface Workshop {
    /** Workshop identifier. */
    id: string;
    /** Workshop display name. */
    name: string;
    /** A postal address. */
    workshop_address?: Address;
}

/** A postal address. */
export type Address = {
    street?: string | null;
    city?: string | null;
    zip?: string | null;
    country_code?: string | null;
} | null;

/** Object for engine oil CSV filter that should be used while getting information */
export interface CsvFilters {
    /** The asset ids of the vehicle. */
    asset_ids?: string[];
    /** The account ids where the vehicles belongs to. */
    account_ids?: string[];
    /** The workshop ids of the vehicles. */
    workshop_ids?: string[];
    /**
     * The key, value of each CSV header. If some keys are not present, the CSV will be returned without them.
     * @minItems 1
     */
    csv_headers: CsvHeader[];
}

export interface CsvHeader {
    /** The header key. A enum of possible headers. */
    header_key?: string;
    /** The translation of the key. This is used to keep the translation in frontend code. */
    header_value?: string;
}

export interface Problem {
    /**
     * An absolute URI that identifies the problem type.  When dereferenced,
     * it SHOULD provide human-readable documentation for the problem type
     * (e.g., using HTML).
     * @format uri
     * @default "about:blank"
     * @example "https://zalando.github.io/problem/constraint-violation"
     */
    type?: string;
    /**
     * A short, summary of the problem type. Written in english and readable
     * for engineers (usually not suited for non technical stakeholders and
     * not localized); example: Service Unavailable
     */
    title?: string;
    /**
     * The HTTP status code generated by the origin server for this occurrence
     * of the problem.
     * @format int32
     * @min 100
     * @max 600
     * @exclusiveMax true
     * @example 503
     */
    status?: number;
    /**
     * A human readable explanation specific to this occurrence of the
     * problem.
     * @example "Connection to database timed out"
     */
    detail?: string;
    /**
     * An absolute URI that identifies the specific occurrence of the problem.
     * It may or may not yield further information if dereferenced.
     * @format uri
     */
    instance?: string;
}

export declare namespace EngineOil {
    /**
     * @description Returns the engine oil fill level data for a given asset. The response includes the current engine oil measurements, status, signal origin, and preconditions if available.
     * @name GetEngineOil
     * @summary Returns engine oil data for an asset
     * @request GET:/engine-oil/readings/{asset_id}
     * @secure
     * @response `200` `EngineOil` OK. Returns engine oil data if available for the given asset. If no engine oil data exists, the response body will be empty.
     * @response `default` `Problem` error occurred - see status code and problem object for more information.
     */
    export namespace GetEngineOil {
        export type RequestParams = {
            /** The asset ID to retrieve engine oil data for */
            assetId: AssetId;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = EngineOil;
    }

    /**
     * @description Returns one engine oil records per requested assets, enriched with vehicle identity, sorted and paginated server-side.
     * @name GetEngineOilTable
     * @summary Returns engine oil data for a set of assets (fleet table)
     * @request POST:/engine-oil/readings
     * @secure
     * @response `200` `EngineOilTableResponse` OK. Returns one enriched engine oil record per accessible asset.
     * @response `default` `Problem` error occurred - see status code and problem object for more information.
     */
    export namespace GetEngineOilTable {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = EngineOilTableRequest;
        export type RequestHeaders = {};
        export type ResponseBody = EngineOilTableResponse;
    }

    /**
     * @description Returns the workshop assignment for the given asset, including the fleet account (customer) with its address and the assigned contact person with phone numbers. Resolved entirely from the asset id.
     * @name GetAssignmentForAsset
     * @summary Returns the workshop assignment details for an asset
     * @request GET:/engine-oil/assignments/{asset_id}
     * @secure
     * @response `200` `Assignment` OK. Returns the assignment details for the asset.
     * @response `default` `Problem` error occurred - see status code and problem object for more information.
     */
    export namespace GetAssignmentForAsset {
        export type RequestParams = {
            /** The asset ID to retrieve engine oil data for */
            assetId: AssetId;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = Assignment;
    }

    /**
     * @description Returns the name and address of the workshop with the given workshop id. The workshop id is obtained from the fleet list (readings) or the assignment.
     * @name GetWorkshop
     * @summary Returns a workshop by its id
     * @request GET:/engine-oil/workshops/{workshop_id}
     * @secure
     * @response `200` `Workshop` OK. Returns the workshop details for the given workshop id.
     * @response `default` `Problem` error occurred - see status code and problem object for more information.
     */
    export namespace GetWorkshop {
        export type RequestParams = {
            /** The workshop id to retrieve */
            workshopId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = Workshop;
    }

    /**
     * No description
     * @tags CsvExport
     * @name CsvExport
     * @summary Returns a CSV file with engine oil data for the filtered assets
     * @request POST:/engine-oil/readings/csv-export
     * @secure
     * @response `200` `File` Success
     * @response `default` `Problem` error occurred - see status code and problem object for more information.
     */
    export namespace CsvExport {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = CsvFilters;
        export type RequestHeaders = {};
        export type ResponseBody = File;
    }
}
